import type { Socket } from 'socket.io-client';

let offset = 0;
const listeners = new Set<() => void>();

function notify() {
	for (const cb of listeners) cb();
}

export function serverNow(): number {
	return Date.now() + offset;
}

export function applyServerTime(serverTime: number, receivedAt = Date.now()) {
	offset = serverTime - receivedAt;
	notify();
}

export function applyTimeSync(t0: number, t1: number, t2 = Date.now()) {
	const rtt = t2 - t0;
	offset = t1 + rtt / 2 - t2;
	notify();
}

export function requestTimeSync(socket: Socket) {
	const t0 = Date.now();
	socket.emit('time-sync', t0, (res: { t0: number; t1: number }) => {
		applyTimeSync(res.t0, res.t1);
	});
}

export function onClockChange(cb: () => void): () => void {
	listeners.add(cb);
	return () => listeners.delete(cb);
}
